import { Box, Skeleton } from '@mui/material';
import { useQuery } from '@tanstack/react-query';

import { Text, api, colors, getQueryProps, isDefined, isTruthy } from 'common';

import { BlockType, type ReactFlowBlockTypeData } from '../../../../types';

interface NodeSubFlowProps {
  data: ReactFlowBlockTypeData;
}

export function NodeSubFlowDecorator(props: NodeSubFlowProps) {
  const { data } = props;
  const { uiBlockType, config } = data;
  const subFlowConfig =
    uiBlockType === BlockType.SubFlowV2
      ? (config as api.FlowDefinition.SubFlowV2BlockConfig)
      : uiBlockType === BlockType.IteratorV2 || uiBlockType === BlockType.Repeat
        ? (
            config as (
              api.FlowDefinition.IteratorV2Block | api.FlowDefinition.RepeatBlock
            )['config']
          ).subFlow
        : undefined;
  const hasSubFlowConfigAndFlowId = isDefined(subFlowConfig) && isTruthy(subFlowConfig.flowId);
  const {
    data: subFlow,
    isPending,
    isError,
  } = useQuery({
    ...getQueryProps(api.client.Flow, 'findSubflowVersion', {
      flowId: subFlowConfig?.flowId ?? '_INVALID_',
      target: subFlowConfig?.versionTarget,
      flowDefinitionId: subFlowConfig?.flowDefinitionId,
    }),
    enabled: hasSubFlowConfigAndFlowId,
  });

  if (!hasSubFlowConfigAndFlowId) {
    return null;
  }
  if (isError) {
    // Ignore such error on the card
    return null;
  }
  return (
    <Box>
      <Box
        border={1}
        borderRadius={1}
        borderColor={colors.extended.yellow[60]}
        paddingX={1}
        paddingY={0.5}
      >
        {isPending ? (
          <Skeleton />
        ) : (
          <Text
            variant="body2"
            sx={{ overflow: 'hidden', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}
          >
            ↳ {subFlow.name}
          </Text>
        )}
      </Box>
    </Box>
  );
}
